module.exports = __webpack_public_path__ + "pc.245c031.png";